import { render } from "./RegioesTabPage.vue?vue&type=template&id=1a7a42ba"
import script from "./RegioesTabPage.vue?vue&type=script&lang=js"
export * from "./RegioesTabPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__